import { Link } from "react-router-dom";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { BRAND } from "@/data/urban";

export const FinalCTA = () => {
  const waText = encodeURIComponent(`Hi Urban Renovations, I am interested in your interior and renovation services. I would like to discuss my requirement.`);
  return (
    <section className="py-20 md:py-24 bg-canvas hairline-b">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-10 text-center">
        <div className="overline text-ink-soft">Ready to start?</div>
        <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink leading-tight">Ready to Transform Your Home?</h2>
        <p className="mt-4 text-ink-soft max-w-2xl mx-auto">Tell us your requirements, space and budget. We'll help you find the right solution.</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link to="/contact" className="inline-flex items-center gap-2 bg-black text-white px-7 py-3.5 rounded-md font-bold uppercase tracking-wider text-sm hover:bg-ink transition-colors">
            Get Free Quote <ArrowRight className="h-4 w-4" />
          </Link>
          <a href={`https://wa.me/${BRAND.whatsapp}?text=${waText}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 border border-hairline text-ink px-7 py-3.5 rounded-md font-bold uppercase tracking-wider text-sm hover:border-ink transition-colors">
            <MessageCircle className="h-4 w-4" /> WhatsApp
          </a>
          <a href={`tel:${BRAND.phoneRaw}`} className="inline-flex items-center gap-2 text-ink px-7 py-3.5 rounded-md font-bold uppercase tracking-wider text-sm hover:opacity-70 transition-opacity">
            <Phone className="h-4 w-4" /> {BRAND.phone}
          </a>
        </div>
      </div>
    </section>
  );
};
